module.exports = __webpack_public_path__ + "static/media/adventureEmergencyIcon.c4601949.png";